import raveExp from '@magalu/rave/template/rave-exp';
import raveIf from '@magalu/rave/template/rave-if';

export const getComponents = props => ({
    'header-preconnect-0': {
      name: `Preconnect`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        list: [
          `https://wx.mlcdn.com.br`,
          `https://a-static.mlcdn.com.br`,
          `https://site-content.magazineluiza.com.br`,
          `https://tom.mlcdn.com.br`,
        ],
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-preconnect-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-google-tag-manager-1': {
      name: `GoogleTagManager`,
      from: `@magalu/ecomm-components/rave/scripts/GoogleTagManager`,
      props: {
        id: `GTM-N9NRZNKX`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-google-tag-manager-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-all-in-2': {
      name: `AllIn`,
      from: `@magalu/ecomm-components/rave/scripts/AllIn`,
      props: {
        strategy: `worker`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-all-in-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-criteo-3': {
      name: `Criteo`,
      from: `@magalu/ecomm-components/rave/scripts/Criteo`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-criteo-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-bing-4': {
      name: `Bing`,
      from: `@magalu/ecomm-components/rave/scripts/Bing`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-bing-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-tik-tok-5': {
      name: `TikTok`,
      from: `@magalu/ecomm-components/rave/scripts/TikTok`,
      props: {
        id: `C1I87V1T0U322RQPSRKG`,
        strategy: `worker`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-tik-tok-5`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-rtbhouse-6': {
      name: `RTBHouse`,
      from: `@magalu/ecomm-components/rave/scripts/RTBHouse`,
      props: {
        id: `msWukR4UlwKQouZSY8IT`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-rtbhouse-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-stewie-7': {
      name: `Stewie`,
      from: `@magalu/ecomm-components/rave/scripts/Stewie`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-stewie-7`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-spotify-ad-analytics-8': {
      name: `SpotifyAdAnalytics`,
      from: `@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics`,
      props: {
        id: `66f417c2d2344c0980e19d4e7f996073`,
        strategy: `worker`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-spotify-ad-analytics-8`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-hotjar-9': {
      name: `Hotjar`,
      from: `@magalu/ecomm-components/rave/scripts/Hotjar`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      props: {
        id: `4936838`,
      },
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-hotjar-9`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-vwo-10': {
      name: `Vwo`,
      from: `@magalu/ecomm-components/rave/scripts/Vwo`,
      id: `header-vwo-10`,
      props: {
        id: `752930`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-11': {
      name: `Loader`,
      from: `@magalu/ecomm-components/rave/Loader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-loader-11`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-state-loader-12': {
      name: `StateLoader`,
      from: `@magalu/ecomm-components/rave/StateLoader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-state-loader-12`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-header-13': {
      name: `Header`,
      from: `@magalu/ecomm-components/rave/Header`,
      props: {
        cartUrl: props?.data?.platform?.cart?.host,
        topCategories: {
          categoryIds: [
            `TE`,
            `ET`,
            `ED`,
            `MO`,
            `IN`,
            `MD`,
          ],
          limit: 6,
          showAllDepartments: true,
        },
        showBasketCount: raveExp({
          '===': [
            props?.route?.cookies?.toggle_header_basket_counter,
            `true`,
          ],
        }),
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-header-13`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-event-page-view-dispatcher-14': {
      name: `EventPageViewDispatcher`,
      from: `@magalu/ecomm-components/rave/EventPageViewDispatcher`,
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-event-page-view-dispatcher-14`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-11-children-page-loading-0': {
      name: `PageLoading`,
      from: `@magalu/ecomm-components/components/PageLoading`,
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-loader-11-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-state-loader-12-children-page-loading-0': {
      name: `PageLoading`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      from: `@magalu/ecomm-components/components/PageLoading`,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `header-state-loader-12-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex-col mt-md rounded-md px-xlg items-start gap-xsm w-[200px] hidden md:flex`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `content-row-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-breadcrumb-0': {
      name: `Breadcrumb`,
      from: `@magalu/ecomm-components/components/Breadcrumb`,
      props: {
        separator: `>`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `content-row-0-children-breadcrumb-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-breadcrumb-0-children-breadcrumb.-item-0': {
      name: `Breadcrumb.Item`,
      from: `@magalu/ecomm-components/components/Breadcrumb`,
      props: {
        children: `Home`,
        href: raveIf([
          raveExp({
            '==': [
              props?.clientConfig?.environment,
              `production`,
            ],
          }),
          `/`,
          `https://mixer.luizalabs.com/`,
        ]),
        color: `primary`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `content-row-0-children-breadcrumb-0-children-breadcrumb.-item-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-breadcrumb-0-children-breadcrumb.-item-1': {
      name: `Breadcrumb.Item`,
      from: `@magalu/ecomm-components/components/Breadcrumb`,
      props: {
        children: `Sua conta`,
        href: `/sua-conta`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `content-row-0-children-breadcrumb-0-children-breadcrumb.-item-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `md:mt-[0px] flex-row px-xlg items-start gap-lg md:pb-hg mt-md`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex-col items-start gap-xsm w-full max-w-[888px]`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex flex-col w-full`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-0-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Sua conta`,
        as: `h1`,
        className: `font-xlg-bold mb-md`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-0-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-0-children-heading-1': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: raveIf([
          props?.data?.userInfo?.name,
          `Olá ${props?.data?.userInfo?.name}. Navegue e gerencie conforme desejar.`,
          ``,
        ]),
        as: `p`,
        className: `font-2xsm-regular`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-0-children-heading-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-0-children-heading-2': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Pedidos`,
        as: `p`,
        className: `font-sm-bold mb-xsm mt-md`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-0-children-heading-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-0-children-list-3': {
      name: `List`,
      from: `@magalu/ecomm-components/components/List`,
      props: {
        className: `list-divided gap-sm rounded-md bg-surface-container-lowest py-2xsm`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-0-children-list-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-0-children-list-3-children-list-item-0': {
      name: `ListItem`,
      from: `ListItem`,
      props: {
        as: `a`,
        children: `Meus pedidos`,
        endIcon: `chevron-right`,
        events: [
          {
            eventArgs: {
              value: {
                content_type: `sua-conta`,
                content_id: `pedidos:meus-pedidos`,
              },
            },
            eventName: `accountlist:click`,
          },
        ],
        href: `https://meuespaco.magazineluiza.com.br/pedidos`,
        startIcon: `mercado`,
        spacing: `gap-xsm py-sm`,
        className: `grow font-xsm-regular text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-0-children-list-3-children-list-item-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-0-children-list-3-children-list-item-1': {
      name: `ListItem`,
      from: `ListItem`,
      props: {
        as: `a`,
        children: `Trocas e cancelamento`,
        endIcon: `chevron-right`,
        events: [
          {
            eventArgs: {
              value: {
                content_type: `sua-conta`,
                content_id: `pedidos:trocas-e-cancelamento`,
              },
            },
            eventName: `accountlist:click`,
          },
        ],
        href: `https://meuespaco.magazineluiza.com.br/pedidos?showtab=listWithTickets`,
        startIcon: `sync`,
        spacing: `gap-xsm py-sm`,
        className: `grow font-xsm-regular text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-0-children-list-3-children-list-item-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-0-children-list-3-children-list-item-2': {
      name: `ListItem`,
      from: `ListItem`,
      props: {
        as: `a`,
        children: `Favoritos`,
        endIcon: `chevron-right`,
        events: [
          {
            eventArgs: {
              value: {
                content_type: `sua-conta`,
                content_id: `pedidos:favoritos`,
              },
            },
            eventName: `accountlist:click`,
          },
        ],
        href: `https://www.magazineluiza.com.br/favoritos/`,
        startIcon: `favorite-border`,
        spacing: `gap-xsm py-sm`,
        className: `grow font-xsm-regular text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-0-children-list-3-children-list-item-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-1': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex flex-col w-full`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-1-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Seus Dados`,
        as: `p`,
        className: `font-sm-bold mb-xsm mt-md`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-1-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-1-children-list-1': {
      name: `List`,
      from: `@magalu/ecomm-components/components/List`,
      props: {
        className: `list-divided gap-sm rounded-md bg-surface-container-lowest py-2xsm`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-1-children-list-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-0': {
      name: `ListItem`,
      from: `ListItem`,
      props: {
        as: `a`,
        children: `Dados pessoais`,
        endIcon: `chevron-right`,
        events: [
          {
            eventArgs: {
              value: {
                content_type: `sua-conta`,
                content_id: `seus-dados:dados-pessoais`,
              },
            },
            eventName: `accountlist:click`,
          },
        ],
        href: raveIf([
          raveExp({
            '==': [
              props?.clientConfig?.environment,
              `production`,
            ],
          }),
          raveIf([
            props?.route?.deviceInfo?.type,
            `https://sacolamobile.magazineluiza.com.br/#/cliente/editar/?next=https://m.magazineluiza.com.br/conta/&origin=magazineluiza`,
            `https://sacola.magazineluiza.com.br/#/cliente/editar/?next=https://www.magazineluiza.com.br/conta/&origin=magazineluiza`,
          ]),
          raveIf([
            props?.route?.deviceInfo?.type,
            `https://sacolamobile-sandbox.luizalabs.com/#/cliente/editar/?next=https%3A//imperio-sandbox.luizalabs.com/conta/&origin=magazineluiza`,
            `https://sacola-sandbox.luizalabs.com/#/cliente/editar/?next=https%3A//imperio-sandbox.luizalabs.com/conta/&origin=magazineluiza`,
          ]),
        ]),
        startIcon: `person-outline`,
        spacing: `gap-xsm py-sm`,
        className: `grow font-xsm-regular text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-1': {
      name: `ListItem`,
      from: `ListItem`,
      props: {
        as: `a`,
        children: `Alterar e-mail ou telefone`,
        endIcon: `chevron-right`,
        events: [
          {
            eventArgs: {
              value: {
                content_type: `sua-conta`,
                content_id: `seus-dados:alterar-email-ou-telefone`,
              },
            },
            eventName: `accountlist:click`,
          },
        ],
        href: raveIf([
          raveExp({
            '==': [
              props?.clientConfig?.environment,
              `production`,
            ],
          }),
          raveIf([
            props?.route?.deviceInfo?.type,
            `https://sacolamobile.magazineluiza.com.br/#/cliente/seu-espaco/`,
            `https://sacola.magazineluiza.com.br/#/cliente/seu-espaco/`,
          ]),
          raveIf([
            props?.route?.deviceInfo?.type,
            `https://sacolamobile-sandbox.luizalabs.com/#/cliente/seu-espaco/`,
            `https://sacola-sandbox.luizalabs.com/#/cliente/seu-espaco/`,
          ]),
        ]),
        startIcon: `alternate-email`,
        spacing: `gap-xsm py-sm`,
        className: `grow font-xsm-regular text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-2': {
      name: `ListItem`,
      from: `ListItem`,
      props: {
        as: `a`,
        children: `Endereços de entrega`,
        endIcon: `chevron-right`,
        events: [
          {
            eventArgs: {
              value: {
                content_type: `sua-conta`,
                content_id: `seus-dados:enderecos-de-entrega`,
              },
            },
            eventName: `accountlist:click`,
          },
        ],
        href: raveIf([
          raveExp({
            '==': [
              props?.clientConfig?.environment,
              `production`,
            ],
          }),
          raveIf([
            props?.route?.deviceInfo?.type,
            `https://sacolamobile.magazineluiza.com.br/#/seu-espaco/endereco-entrega/`,
            `https://sacola.magazineluiza.com.br/#/seu-espaco/endereco-entrega/`,
          ]),
          raveIf([
            props?.route?.deviceInfo?.type,
            `https://sacolamobile-sandbox.luizalabs.com/#/seu-espaco/endereco-entrega/`,
            `https://sacola-sandbox.luizalabs.com/#/seu-espaco/endereco-entrega/`,
          ]),
        ]),
        startIcon: `local-shipping`,
        spacing: `gap-xsm py-sm`,
        className: `grow font-xsm-regular text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-3': {
      name: `ListItem`,
      from: `ListItem`,
      props: {
        as: `a`,
        children: `Formas de pagamento`,
        endIcon: `chevron-right`,
        events: [
          {
            eventArgs: {
              value: {
                content_type: `sua-conta`,
                content_id: `seus-dados:formas-de-pagamento`,
              },
            },
            eventName: `accountlist:click`,
          },
        ],
        href: `/conta/cartoes/`,
        spa: true,
        startIcon: `vale-compra`,
        spacing: `gap-xsm py-sm`,
        className: `grow font-xsm-regular text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-4': {
      name: `ListItem`,
      from: `ListItem`,
      props: {
        as: `a`,
        children: `Senha de acesso`,
        endIcon: `chevron-right`,
        events: [
          {
            eventArgs: {
              value: {
                content_type: `sua-conta`,
                content_id: `seus-dados:senha-de-acesso`,
              },
            },
            eventName: `accountlist:click`,
          },
        ],
        href: raveIf([
          raveExp({
            '==': [
              props?.clientConfig?.environment,
              `production`,
            ],
          }),
          raveIf([
            props?.route?.deviceInfo?.type,
            `https://sacolamobile.magazineluiza.com.br/#/cliente/editar`,
            `https://sacola.magazineluiza.com.br/#/cliente/editar`,
          ]),
          raveIf([
            props?.route?.deviceInfo?.type,
            `https://sacolamobile-sandbox.luizalabs.com/#/cliente/editar`,
            `https://sacola-sandbox.luizalabs.com/#/cliente/editar`,
          ]),
        ]),
        startIcon: `locker-outline`,
        spacing: `gap-xsm py-sm`,
        className: `grow font-xsm-regular text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-2': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex flex-col w-full`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-2-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Comunicação`,
        as: `p`,
        className: `font-sm-bold mb-xsm mt-md`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-2-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-2-children-list-1': {
      name: `List`,
      from: `@magalu/ecomm-components/components/List`,
      props: {
        className: `list-divided gap-sm rounded-md bg-surface-container-lowest py-2xsm`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-2-children-list-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-2-children-list-1-children-list-item-0': {
      name: `ListItem`,
      from: `ListItem`,
      props: {
        as: `a`,
        children: `Central de atendimento`,
        endIcon: `chevron-right`,
        events: [
          {
            eventArgs: {
              value: {
                content_type: `sua-conta`,
                content_id: `comunicacao:central-de-atendimento`,
              },
            },
            eventName: `accountlist:click`,
          },
        ],
        href: `https://www.magazineluiza.com.br/central-de-atendimento/`,
        startIcon: `headset-mic`,
        spacing: `gap-xsm py-sm`,
        className: `grow font-xsm-regular text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-2-children-list-1-children-list-item-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'beforesidebar-row-0-children-row-0-children-row-2-children-list-1-children-list-item-1': {
      name: `ListItem`,
      from: `ListItem`,
      props: {
        as: `a`,
        children: `Configuração de notificação`,
        endIcon: `chevron-right`,
        events: [
          {
            eventArgs: {
              value: {
                content_type: `sua-conta`,
                content_id: `comunicacao:configuracao-de-notificacao`,
              },
            },
            eventName: `accountlist:click`,
          },
        ],
        href: raveIf([
          props?.route?.deviceInfo?.type,
          `https://sacolamobile.magazineluiza.com.br/#/cliente/editar#notificacoes`,
          `https://sacola.magazineluiza.com.br/#/cliente/editar#notificacoes`,
        ]),
        startIcon: `notifications-add`,
        spacing: `gap-xsm py-sm`,
        className: `grow font-xsm-regular text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `beforesidebar-row-0-children-row-0-children-row-2-children-list-1-children-list-item-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'sidebar-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex-col mx-auto md:mx-[0] mb-hg mt-lg md:mt-[108px] rounded-md items-start gap-xsm w-[200px] p-md bg-surface-container-lowest`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `sidebar-row-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'sidebar-row-0-children-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `h-[100px] w-full bg-danger-lighter-inverted justify-center items-center`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `sidebar-row-0-children-row-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'sidebar-row-0-children-row-0-children-tom-icon-quero-de-casamento-0': {
      name: `TomIconQueroDeCasamento`,
      from: `@magalu/tom-icons/react/ts`,
      namedImport: true,
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `sidebar-row-0-children-row-0-children-tom-icon-quero-de-casamento-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'sidebar-row-0-children-heading-1': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Quero de casamento`,
        as: `p`,
        className: `font-xsm-bold mt-sm mx-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `sidebar-row-0-children-heading-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'sidebar-row-0-children-heading-2': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Organiza tudo sem preocupações e transforma seus presentes em créditos para usar como quiser`,
        as: `p`,
        className: `font-2xsm-regular md:mt-auto m-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `sidebar-row-0-children-heading-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'sidebar-row-0-children-button-3': {
      name: `Button`,
      from: `@magalu/ecomm-components/rave/Button`,
      props: {
        as: `a`,
        label: `Saiba mais`,
        variant: `outline`,
        color: `primary`,
        size: `small`,
        full: true,
        centered: true,
        href: `https://www.querodecasamento.com.br/lista-de-casamento?utm_source=magazineluiza.com.br&utm_medium=referral&utm_campaign=convidados`,
        eventButton: `qdccard:click`,
        eventValue: {
          content_type: `sua-conta`,
          content_id: `quero-de-casamento:saiba-mais`,
        },
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `sidebar-row-0-children-button-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-footer-0': {
      name: `Footer`,
      from: `@magalu/ecomm-components/components/Footer`,
      props: {
        as: `div`,
        extraContent: {
          links: [
            {
              title: `Magalu`,
              links: [
                {
                  text: `Quem somos`,
                  href: `https://ri.magazineluiza.com.br/show.aspx?idCanal=urUqu4hANldyCLgMRgOsTw==`,
                },
                {
                  text: `Nossas lojas`,
                  href: `https://lojas.magazineluiza.com.br/`,
                },
                {
                  text: `Trabalhe conosco`,
                  href: `https://carreiras.magazineluiza.com.br/`,
                },
                {
                  text: `Programa ouro`,
                  href: `https://especiais.magazineluiza.com.br/dia-de-ouro/`,
                },
                {
                  text: `Assessoria de imprensa`,
                  href: `https://ri.magazineluiza.com.br/show.aspx?idCanal=Zkqmz6KAKUXGYIsGZCxxhg==`,
                },
                {
                  text: `Investidores`,
                  href: `https://ri.magazineluiza.com.br/`,
                  gap: `12px`,
                  img: {
                    src: `https://wx.mlcdn.com.br/site/desk/footer/flag-brasil.svg`,
                    className: `w-4 h-4 inline-block object-contain`,
                    alt: `Flag Bandeira Brasil`,
                  },
                },
                {
                  text: `Investors`,
                  href: `https://ri.magazineluiza.com.br/Default.aspx?idioma=enu&linguagem=en#`,
                  gap: `12px`,
                  img: {
                    src: `https://wx.mlcdn.com.br/site/desk/footer/flag-usa.svg`,
                    className: `w-4 h-4 inline-block object-contain`,
                    alt: `Flag Bandeira USA`,
                  },
                },
              ],
            },
            {
              title: `Para sua empresa`,
              links: [
                {
                  text: `Compre online aqui`,
                  href: `https://www.magaluempresas.com.br/`,
                },
                {
                  text: `Nossas soluções`,
                  href: `https://institucional.magaluempresas.com.br/`,
                },
                {
                  text: `Vendas corporativas`,
                  href: `https://institucional.magaluempresas.com.br/magalu-empresas`,
                },
                {
                  text: `Incentivo e fidelidade`,
                  href: `https://institucional.magaluempresas.com.br/incentivo-e-fidelidade`,
                },
                {
                  text: `Programas de benefício`,
                  href: `https://institucional.magaluempresas.com.br/programa-beneficios`,
                },
                {
                  text: `Catalogo para e-commerce`,
                  href: `https://institucional.magaluempresas.com.br/catalogo-ecommerce`,
                },
                {
                  text: `Televendas corporativas`,
                  href: `https://institucional.magaluempresas.com.br/televendas-corporativas`,
                },
              ],
            },
            {
              title: `Atendimento`,
              links: [
                {
                  text: `Atendimento`,
                  href: `https://atendimento.magazineluiza.com.br/hc/pt-br/`,
                },
                {
                  text: `Termo de compra e venda`,
                  href: `https://especiais.magazineluiza.com.br/termo-compra-venda/`,
                },
                {
                  text: `Arrependimento ou desistência`,
                  href: `https://www.magazineluiza.com.br/central-de-atendimento/duvidas-frequentes/arrependimento-ou-desistencia/`,
                },
                {
                  text: `Trocas e devoluções`,
                  href: `https://www.magazineluiza.com.br/central-de-atendimento/duvidas-frequentes/troca-e-devolucao/`,
                },
                {
                  text: `Assistência técnica dos fabricantes`,
                  href: `https://www.magazineluiza.com.br/central-de-atendimento/fornecedores/`,
                },
                {
                  text: `Política de privacidade`,
                  href: `https://especiais.magazineluiza.com.br/politica-de-privacidade/`,
                },
                {
                  text: `Regulamentos`,
                  href: `https://especiais.magazineluiza.com.br/regulamentos/`,
                },
              ],
            },
            {
              title: `Seja nosso parceiro`,
              links: [
                {
                  text: `Venda seus produtos`,
                  href: `https://universo.magalu.com/`,
                },
                {
                  text: `Seja influenciador Magalu`,
                  href: `https://www.magazinevoce.com.br/`,
                },
                {
                  text: `Proteção de marcas`,
                  href: `https://especiais.magazineluiza.com.br/protecao-de-marcas/`,
                },
                {
                  text: `Portal financeiro`,
                  href: `https://www.accesstage.com.br/PortalFinanceiro/login.jsf`,
                },
              ],
            },
          ],
          certificates: [
            {
              href: `https://www.compreconfie.com.br/100515`,
              img: {
                src: `https://selo.compreconfie.com.br/reputation/100515.png`,
                className: `max-h-[54px]`,
                alt: `Selo Compre & Confie`,
              },
            },
            {
              href: `http://www.ebit.com.br/552/selo`,
              img: {
                src: `https://newimgebit-a.akamaihd.net/ebitBR/selo/img_552.png`,
                className: `max-h-[43px]`,
                alt: `Inativa`,
              },
            },
            {
              href: `https://www.magazineluiza.com.br/estaticas/seguranca-maxima/`,
              icon: {
                id: `service-house-security`,
                text: `Certificados e segurança`,
              },
            },
          ],
        },
        topLinks: [
          {
            text: `Blog da Lu`,
            href: `https://www.magazineluiza.com.br/blog-da-lu/`,
          },
          {
            text: `Nossa lojas`,
            href: `https://lojas.magazineluiza.com.br/`,
            rel: `noopener`,
          },
          {
            text: `Tenha sua loja`,
            href: `https://www.influenciadormagalu.com.br/`,
            rel: `noopener`,
          },
          {
            text: `Regulamento`,
            href: `https://especiais.magazineluiza.com.br/regulamentos/`,
            rel: `noopener`,
          },
          {
            text: `Acessibilidade`,
            href: `https://especiais.magazineluiza.com.br/acessibilidade/`,
            rel: `noopener`,
          },
          {
            text: `Segurança e Privacidade`,
            href: `https://especiais.magazineluiza.com.br/seguranca/`,
            rel: `noopener`,
          },
        ],
        middleContent: [
          `Preços e condições de pagamento exclusivos para compras via internet, podendo variar nas lojas físicas. Ofertas válidas na compra de até 5 peças de cada produto por cliente, até o término dos nossos estoques para internet. Caso os produtos apresentem divergências de valores, o preço válido é o da sacola de compras.`,
          `O Magazine Luiza atua como correspondente no País, nos termos da Resolução CMN nº 4.935/2021, e encaminha propostas de cartão de crédito e operações de crédito para a Luizacred S.A Sociedade de Crédito, Financiamento e Investimento inscrita no CNPJ sob o nº 02.206.577/0001-80.`,
          [
            {
              icon: `chat`,
              text: `Compre pelo chat`,
              href: `https://atendimento.magazineluiza.com.br/hc/pt-br?open=chat_televendas`,
            },
            {
              text: [
                `ou compre pelo telefone:`,
                `0800 773 3838`,
              ],
              className: `text-center font-xsm-medium`,
            },
          ],
        ],
        aboutTheCompany: `Magazine Luiza S/A - CNPJ: 47.960.950/1088-36 - Endereço: Rua Arnulfo de Lima, 2385 - Vila Santa Cruz, Franca/SP - CEP 14.403-471 ® Magazine Luiza – Todos os direitos reservados.`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      id: `footer-footer-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-alert-feedback-1': {
      name: `AlertFeedback`,
      id: `footer-alert-feedback-1`,
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: false,
      hasSpacing: false,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
  });

export const dataSource = {
  "graphql": {
    "host": "https://federation.magazineluiza.com.br",
    "timeout": 5000,
    "credentials": "include",
    "serverDefaultOptions": {
      "query": {
        "errorPolicy": "all",
        "fetchPolicy": "cache-first"
      },
      "watchQuery": {
        "errorPolicy": "all",
        "fetchPolicy": "cache-first"
      },
      "mutate": {
        "errorPolicy": "all",
        "fetchPolicy": "no-cache"
      }
    }
  },
  "dataSourceDir": "/src/datasource"
}

export const getHeadProps = (props) => ({
    links: [
      {
        rel: `shortcut icon`,
        href: `https://site-content.magazineluiza.com.br/static/img/default/favicon-cc4cf323.png`,
      },
      {
        rel: `shortcut icon`,
        type: `image/ico`,
        href: `https://site-content.magazineluiza.com.br/static/img/default/favicon-cc4cf323.png`,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/fonts/magalu-ui-variable/files/MagaluUIVariable.woff2`,
        crossOrigin: ``,
      },
    ],
    title: `Sua Conta - Magazine Luiza`,
  });

export const componentsList = [
  "Preconnect",
  "GoogleTagManager",
  "AllIn",
  "Criteo",
  "Bing",
  "TikTok",
  "RTBHouse",
  "Stewie",
  "SpotifyAdAnalytics",
  "Hotjar",
  "Vwo",
  "Loader",
  "StateLoader",
  "Header",
  "EventPageViewDispatcher",
  "PageLoading",
  "Row",
  "Breadcrumb",
  "Breadcrumb.Item",
  "Heading",
  "List",
  "ListItem",
  "TomIconQueroDeCasamento",
  "Button",
  "Footer",
  "AlertFeedback"
];

export const routeInfo = {
  id: 'your-account',
  name: 'sua-conta',
  pathPattern: '/conta',
  pathAliases: {},
  parser: {
    query: {},
    cookie: {},
  },
  renderMethod: 'SSR',
  forwardCookies: '',
  forwardHeaders: 'user-agent,referer,theme,x-forwarded-for'
};

export const manifest = {
  "isMiniApp": false,
  "useTypescript": true
};

export const getGlobalClassName = props => ([
    `bg-surface-container-lower`,
    raveExp({
      '??': [
        props?.route?.cookies?.theme,
        ``,
      ],
    }),
  ]).join(' ').trim();

export const getPageVariables = props => ({
  });

export const middlewaresArgs = ({ 
      "getUserInfo": (props) => ({
  }),
      "getPlatformEnvs": (props) => ({
  }),
      "getVersions": (props) => ({
  }),
      "checkLogin": (props) => ({
    clientConfig: props?.clientConfig,
  }),
 });


export const config = {
  assetPrefix: '/imperio',
};
